import { useEffect, useRef } from 'react';

// AdBanner — renders a Google AdSense unit
// Props:
//   slot       — your ad unit slot ID from AdSense (e.g. "1234567890")
//   format     — 'auto' | 'fluid' | 'rectangle' (default: 'auto')
//   style      — optional container style overrides

export default function AdBanner({ slot, format = 'auto', style = {} }) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    // Only push once per mount and only if adsbygoogle is available
    if (pushed.current) return;
    pushed.current = true;
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      // AdSense not loaded yet — fails silently
    }
  }, []);

  const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-4081771413267583';

  // Don't render if no slot configured yet
  if (!slot) return null;

  return (
    <div style={{
      width: '100%',
      overflow: 'hidden',
      borderRadius: 'var(--radius)',
      background: 'rgba(255,255,255,0.02)',
      border: '1px solid var(--border)',
      ...style,
    }}>
      <p style={{
        fontSize: '0.6rem',
        color: 'var(--text-muted)',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        textAlign: 'center',
        padding: '4px 0 0',
        margin: 0,
      }}>
        Advertisement
      </p>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
